module.exports = {"411403001":"古城街道","411403002":"文化街道","411403003":"东方街道","411403004":"新城街道","411403006":"宋城街道","411403007":"古宋街道","411403100":"宋集镇","411403101":"郭村镇","411403102":"李口镇","411403103":"高辛镇","411403104":"坞墙镇","411403105":"冯桥镇","411403106":"路河镇","411403107":"闫集镇","411403108":"毛固堆镇","411403204":"包公庙乡","411403205":"娄店乡","411403208":"勒马乡","411403209":"临河店乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411403.json
// module id = 1776
// module chunks = 0